import { render, staticRenderFns } from "./vipDetail.vue?vue&type=template&id=e33723e8&scoped=true&"
import script from "./vipDetail.vue?vue&type=script&lang=js&"
export * from "./vipDetail.vue?vue&type=script&lang=js&"
import style0 from "./vipDetail.vue?vue&type=style&index=0&id=e33723e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33723e8",
  null
  
)

export default component.exports